export default {"src":"/_next/static/media/section2.44be1454.svg","height":309,"width":492,"blurWidth":0,"blurHeight":0};